import React from 'react';
import { Field } from 'redux-form';
import { VirtualizedSelect } from 'components/UIForm';
import { DownloadIcon } from 'theme/icon';
import styles from './styles.scss';
import { IListControl } from './files.interface';

export const ListControl: React.FC<IListControl> = props => {
  const {
    isUploadAccess,
    themeColor = '#2787F5',
    allDocsDownloadLink,
    uploadBtn,
    isAccessDownloadAll,
    options,
    docs,
    filterPlaceholder,
  } = props;
  return (
    <div className={styles.control}>
      <Field
        name="tag"
        component={VirtualizedSelect}
        placeholder={filterPlaceholder}
        options={options}
        labelKey="tag"
        valueKey="tag"
        multi={false}
        clearable
        style={{ width: 310 }}
      />
      <div className={styles.control_buttons}>
        {isAccessDownloadAll && docs.length > 0 && (
          <form action={allDocsDownloadLink} method="post">
            <button
              style={{
                color: themeColor,
              }}
              className={styles.download_all}
              type="submit"
              name="download"
              value={JSON.stringify(
                docs.map(d => ({ hash: d.hash, name: d.name, extension: d.extension, bucket: d.bucket })),
              )}
            >
              <DownloadIcon filled fill={themeColor} />
              Скачать все
            </button>
          </form>
        )}
        {isUploadAccess && docs.length > 0 && uploadBtn && <div className={styles.upload}>{uploadBtn}</div>}
      </div>
    </div>
  );
};
